import { Check, Close } from '@mui/icons-material';
import { Paper, TableContainer, Table, TableHead, TableCell, Typography, TableBody, TableRow } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const TuoteHintarivit = ({ tuote }) => {
  const { t } = useTranslation();

  if (!tuote.hintarivit || !tuote.hintarivit.hintarivit) {
    return null;
  }

  const summa = tuote.hintarivit.hintarivit.reduce((total, hintarivi) => {
    let finalHinta = 0;
    if (hintarivi.hinta) {
      finalHinta = hintarivi.hinta;

      if (!hintarivi.alvSisaltyy) {
        finalHinta += finalHinta * (hintarivi.alv / 100);
      }

      if (hintarivi.alennus && hintarivi.alennus != 0) {
        finalHinta -= finalHinta * (hintarivi.alennus / 100);
      }

      if (tuote.maara && tuote.maara != 0) {
        finalHinta *= tuote.maara;
      }

      return total + finalHinta;
    }
    else {
      return 0;
    }
  }, 0);

  return (
    <Paper>
      <Typography sx={{ marginTop: '1em', padding: '0.5em' }}>{tuote.nimi.tekstit.FIN}</Typography>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{t('tuoteHintarivit.name')}</TableCell>
              <TableCell align="right">{t('tuoteHintarivit.price')}</TableCell>
              <TableCell align="right">{t('tuoteHintarivit.amount')}</TableCell>
              <TableCell align="right">{t('tuoteHintarivit.discount')}</TableCell>
              <TableCell align="right">{t('tuoteHintarivit.alv')}</TableCell>
              <TableCell align="right">{t('tuoteHintarivit.alvInc')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              tuote.hintarivit.hintarivit.map(hintarivi => (
                <TableRow key={hintarivi.hintariviId}>
                  <TableCell>{hintarivi.nimi}</TableCell>
                  <TableCell align="right">{hintarivi.hinta}</TableCell>
                  <TableCell align="right">{tuote.maara}</TableCell>
                  <TableCell align="right">{hintarivi.alennus}</TableCell>
                  <TableCell align="right">{hintarivi.alv}</TableCell>
                  <TableCell align="right">{hintarivi.alvSisaltyy ? <Check /> : <Close />}</TableCell>
                </TableRow>
              ))
            }
            <TableRow sx={{ backgroundColor: '#f0f0f0' }}>
              <TableCell>{t('tuoteHintarivit.sum')}</TableCell>
              <TableCell align="right">{summa}</TableCell>
              <TableCell />
              <TableCell />
              <TableCell />
              <TableCell />
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default TuoteHintarivit;
